<script setup>
import { computed } from 'vue';

import { providerFormContent } from '../../helpers/kraftchatAIProviderConfig';
import KraftchatAIProviderCard from './KraftchatAIProviderCard.vue';

const props = defineProps({
  providerCredentials: {
    type: Array,
    default: () => [],
  },
  editingCredentialId: {
    type: Number,
    default: null,
  },
  savingCredentialId: {
    type: Number,
    default: null,
  },
  deletingProviderId: {
    type: Number,
    default: null,
  },
  credentialTestState: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits([
  'editProvider',
  'deleteProvider',
  'updateProvider',
  'cancelEdit',
  'testProvider',
]);

const hasProviderCredentials = computed(() => {
  return props.providerCredentials.length > 0;
});

const handleUpdateProvider = (credential, payload) => {
  emit('updateProvider', credential, payload);
};
</script>

<template>
  <div class="space-y-3">
    <div class="space-y-1">
      <h3 class="text-sm font-semibold text-n-slate-12">
        {{ providerFormContent.listTitle }}
      </h3>

      <p class="text-sm leading-6 text-n-slate-11">
        {{ providerFormContent.listDescription }}
      </p>
    </div>

    <p
      v-if="!hasProviderCredentials"
      class="rounded-xl border border-dashed border-n-weak bg-n-background p-4 text-sm text-n-slate-11"
    >
      {{ providerFormContent.emptyListTitle }}
    </p>

    <div v-else class="grid gap-3 md:grid-cols-2">
      <KraftchatAIProviderCard
        v-for="credential in providerCredentials"
        :key="credential.id"
        :credential="credential"
        :is-editing="editingCredentialId === credential.id"
        :is-saving="savingCredentialId === credential.id"
        :is-deleting="deletingProviderId === credential.id"
        :test-state="credentialTestState[credential.id]"
        @edit-provider="emit('editProvider', $event)"
        @delete-provider="emit('deleteProvider', $event)"
        @update-provider="handleUpdateProvider"
        @cancel-edit="emit('cancelEdit')"
        @test-provider="emit('testProvider', $event)"
      />
    </div>
  </div>
</template>
